// Vendor imports
import { Fancybox } from "@fancyapps/ui"
import Alpine from "alpinejs"
import collapse from "@alpinejs/collapse"
import focus from "@alpinejs/focus"
import intersect from "@alpinejs/intersect"
import breakpoint from "alpinejs-breakpoints"
import persist from '@alpinejs/persist'
 import { gsap } from "gsap"
import { SplitText } from "gsap/SplitText";


gsap.registerPlugin(SplitText) 

Alpine.plugin(persist)
Alpine.plugin(intersect)
Alpine.plugin(breakpoint)
Alpine.plugin(collapse)
Alpine.plugin(focus)
window.Alpine = Alpine
window.AlpineBreakpointPluginBreakpointsList = [
	"xs",
	"sm",
	"md",
	"lg",
	"xl",
	"2xl",
	"3xl",
]
window.Alpine.start()

import "lazysizes/plugins/respimg/ls.respimg"
import "lazysizes/plugins/parent-fit/ls.parent-fit"
import "lazysizes"
import "lazysizes/plugins/object-fit/ls.object-fit"

// Module imports

import "./modules/svgIconSprite"
import "./modules/fancyapps"
import "./modules/marquee"
import "./modules/swiper"
import "./modules/smoothScroll"
import "./modules/video-fit"
import "./modules/carousel"
import "./modules/base"
import "./modules/google-maps"
import "./modules/filters"
import "./modules/preloader"

 // Full width - Text
window.addEventListener('DOMContentLoaded', (event) => {
    adjustTextSize();

    window.addEventListener('resize', () => {
        adjustTextSize();
    });
});

function adjustTextSize() {
    // Assuming the elements have the class 'dynamic-container' and 'dynamic-text'
    const dynamicContainers = document.querySelectorAll('.dynamic-container');
    const dynamicTexts = document.querySelectorAll('.dynamic-text');

    dynamicContainers.forEach((dynamicContainer, index) => {
        const containerWidth = dynamicContainer.offsetWidth + 40;
        const dynamicTextWidth = dynamicTexts[index].offsetWidth;

        const fontSize = (containerWidth / dynamicTextWidth) * parseFloat(window.getComputedStyle(dynamicTexts[index]).fontSize);

        dynamicTexts[index].style.fontSize = fontSize + 'px';
    });
}

// Custom scrollbar for window
if (navigator.userAgent.indexOf('Windows') !== -1) {
    document.body.classList.add('windows-scrollbar');
  }


/* Noarlunga Animation */
import "./modules/livenoarlunga_animation"
import "./modules/southwark_animation"


// Wait until Formie has been loaded and initialized (FORMIE on BLITCH SITES)
window.addEventListener('DOMContentLoaded',()=>{
        document.addEventListener('onFormieInit', (event) => {
        // Fetch the Form Factory once it's been loaded
        let Formie = event.detail.formie;
        // Refresh the necessary bits that are statically cached (CSRF inputs, captchas, etc)
        Formie.refreshForCache(event.detail.formId);
    });
})